'use client';

import {
  Content as RdxContent,
  DropdownMenuContentProps as RdxContentProps,
  Item as RdxItem,
  DropdownMenuItemProps as RdxItemProps,
  Root as RdxRoot,
  DropdownMenuProps as RdxRootProps,
  Trigger as RdxTrigger,
} from '@radix-ui/react-dropdown-menu';
import React, { PropsWithChildren } from 'react';

import { cn } from '../../utils/helpers.ts';

export const DropdownMenu: React.FC<RdxRootProps> = ({
  children,
  ...props
}) => {
  return <RdxRoot {...props}>{children}</RdxRoot>;
};

export const DropdownMenuTrigger: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return <RdxTrigger asChild>{children}</RdxTrigger>;
};

export const DropdownMenuContent: React.FC<
  PropsWithChildren & {
    align?: RdxContentProps['align'];
    className?: string;
    sideOffset?: RdxContentProps['sideOffset'];
  }
> = ({ align, className, children, sideOffset }) => {
  return (
    <RdxContent
      align={align}
      className={cn('DropdownMenu', {
        [className!]: !!className,
      })}
      sideOffset={sideOffset}
    >
      {children}
    </RdxContent>
  );
};

export const DropdownMenuItem: React.FC<RdxItemProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <RdxItem className={className} {...props}>
      {children}
    </RdxItem>
  );
};
